module.exports = __webpack_public_path__ + "media/bootstrap-icons/card-text-b73260c8.svg";